import { buildProps, definePropType } from '@ll-plus/utils'

import type { ExtractPropTypes } from 'vue'
import type Icon from './icon.vue'

export const iconProps = buildProps({
  // buildProps和defineprops一样
  /**
   * @description icon的类型
   */
  iconName: {
    type: String
  },
  /**
   * @description svg 的 fill 颜色
   */
  color: {
    type: String
  },
  /**
   * @description SVG 图标的大小，size x size
   */
  size: {
    type: definePropType<number | string>([Number, String])
  }
} as const)

// props
export type IconProps = ExtractPropTypes<typeof iconProps> // ExtractPropTypes和defineCpmponent类似

// instance
export type IconInstance = InstanceType<typeof Icon>
